<template>
    <svg class="icon">
        <use :xlink:href="href"></use>
    </svg>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const props = defineProps({
    name: String
});

const href = ref('');

onMounted(() => {
    href.value = `/icones/icons.svg#icon-${props.name}`;
});
</script>